module.exports = __webpack_public_path__ + "files/89883e5de8dbd04982a4583c8e192c48.svg";